import { useQuery } from '@tanstack/react-query';
import { kpiApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';
import type { AceMonthlyTrendParams } from '../types/api.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business ACE 月次トレンドデータをTanStack Query経由で取得。月数指定で月別目標pt/実績pt/人月の時系列を返す
 * @graph-connects /kpi/ace-monthly-trend [calls] ACE月次トレンドAPI呼び出し
 * @graph-connects kpiApi.getAceMonthlyTrend [calls] ACE月次トレンドAPIクライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function useAceMonthlyTrend(params?: AceMonthlyTrendParams) {
  return useQuery({
    queryKey: queryKeys.kpi.aceMonthlyTrend(params),
    queryFn: () => kpiApi.getAceMonthlyTrend(params),
  });
}
